import { Component, inject } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { Amplify } from "aws-amplify";
import {
  AmplifyAuthenticatorModule,
  AuthenticatorService,
} from "@aws-amplify/ui-angular";
import { environment } from "src/environments/environment.development";
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { HeaderComponent } from "./layouts/full/vertical/header/header.component";
import { TranslateService } from "@ngx-translate/core";
import { CoreService } from "./services/core.service";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, AmplifyAuthenticatorModule, LoaderComponent],
  templateUrl: "./app.component.html",
})
export class AppComponent {
  title = "Hub";
  router = inject(Router);
  translate = inject(TranslateService);
  settings = inject(CoreService);
  constructor(public authenticator: AuthenticatorService) {
    Amplify.configure({
      API: {
        REST: {
          ["gateway-api"]: {
            endpoint: environment.baseApiUrl,
            region: "us-east-2",
          },
        },
      },
      Auth: {
        Cognito: {
          userPoolId: "us-east-2_UGbUdGQ7L",
          userPoolClientId: "2n92u081l88s2gi1qh6an17hk7",
          signUpVerificationMethod: "code",
          loginWith: {
            email: true,
            oauth: {
              domain: environment.oAuthDomain,
              scopes: ["phone", "email", "openid"],
              redirectSignIn: [environment.baseAppUrl],
              redirectSignOut: [environment.baseAppUrl],
              responseType: "code", // Using Authorization Code Grant Flow
              //providers: ["Amazon"],
            },
          },
        },
      },
    });
  }
  ngOnInit(): void {
    const savedLang = this.settings.getLanguage();

    const returnUrl = localStorage.getItem("redirectUrl");

    if (returnUrl) {
      localStorage.removeItem("redirectUrl");
      setTimeout(() => {
        this.router.navigateByUrl(returnUrl);
      }, 0);
    }
  }
}
